import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCompanyExchangeData } from "api/companyExchange";

export const downloadFinancialMarketData = createAsyncThunk("financial-market/download", async () => {
  return fetchCompanyExchangeData();
});
